module.exports = "<div class=myswitch-wrapper><div class=inframe v-on=\"click: onSwitch\" v-class=\"off: !value\"><div class=on-text>{{trueText}}</div><div class=handle></div><div class=off-text>{{falseText}}</div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/controls/custom-switch.vue
// module id = 85
// module chunks = 0